const Provider = require("./Provider");
const PropTypes = require("prop-types");
const CrudStoreFabricator = require("stores/abstract/CrudStoreFabricator");
const inject = require("../decorators/Injector");
const shortid = require("shortid");

@inject(["store", "context"])
class Store extends Provider {

    /////////////////////////////////
    // Statics
    /////////////////////////////////

    static get propTypes() {
        return {
            store: PropTypes.any,
            context: PropTypes.any,
            constraints: PropTypes.any,
            resource: PropTypes.string,
            autoFetch: PropTypes.bool,
            frozen: PropTypes.array,
            group: PropTypes.string
        };
    }

    static get defaultProps() {
        return {
            constraints: {},
            autoFetch: false,
            group: null,
            context: null,
            frozen: [],
            direct: null
        };
    }

    /////////////////////////////////
    // Helpers
    /////////////////////////////////

    componentDidMount() {
        if (this.props.store) {
            if (this.props.parent && typeof(this.props.parent) === 'function') {
                this.props.store.onActiveUpdated(this.name, active => {
                    this.store.fetch();
                });
            }

        }
    }

    fetch() {
    	this.store.constrain(this.constraints);
	}

    get name() {
        return ["provider", "store", this.props.resource, this.props.group].join('_');
    }

    get constraints() {
        return {
            [this.name]: () => {

                let constraints = {...this.props.constraints};

                if(this.frozen.length > 0){
                    constraints.frozen = this.frozen;
                }

                if (this.props.store) {
                    if (this.props.parent && typeof(this.props.parent) === 'function') {
                        constraints = {...constraints, ...this.props.parent(this.props.store.active)};
                    }
                }

                //console.log('RESOLVING CONSTRAINTS', constraints);

                return constraints;
            }
        };
    }

    get frozen() {
        return this.props.frozen.filter(f => f);
    }

    get store() {

        let store = null;

        if(this.props.direct){
            store = this.props.direct;

        } else {

            let autoFetch = this.props.autoFetch;
            if(this.props.active){
                autoFetch = false;
            }

            store = CrudStoreFabricator.create(this.props.resource, this.constraints, autoFetch, this.props.group, this.props.context);

            if(typeof this.props.onBoot === 'function'){
                this.props.onBoot(store);
            }

        }

        if (this.props.store && this.props.parent) {
            store.setParent(this.props.store);
        }

        if(this.props.context){
            store.setContext(this.props.context);
        }

        store.replaceFrozen(this.frozen);

        if(typeof(this.props.onActiveUpdated) === 'function'){
            store.onActiveUpdated(this.name+'_custom_callback', active => {
                this.props.onActiveUpdated(active);
            });
        }
        return store;
    }

    resolveStore() {

        let store = this.store;
        if (store !== null) {
            if (this.props.context) {
                store.setContext(this.props.context);
            }
            return store;
        }

        throw new Error('Failed to resolve and provide store');
    }

    get providerProps() {
        return {
            store: this.resolveStore()
        };
    }

}

module.exports = Store;
